import React from 'react';
import { motion } from 'framer-motion';
export function HumanImpact() {
  return <section className="py-24 bg-white overflow-hidden" data-id="element-178">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-179">
        <div className="grid lg:grid-cols-12 gap-12 items-center" data-id="element-180">
          {/* Text Content */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="lg:col-span-4" data-id="element-181">
            <h2 className="text-brand-gold font-semibold tracking-wider uppercase text-sm mb-3" data-id="element-182">
              Our Philosophy
            </h2>
            <h3 className="text-4xl md:text-5xl font-serif text-brand-navy mb-6 leading-tight" data-id="element-183">
              Behind every claim is a person.
            </h3>
            <p className="text-lg text-gray-600 leading-relaxed mb-6" data-id="element-184">
              Workers' compensation isn't just about managing medical bills and
              processing paperwork. It's about helping real people recover from
              unexpected injuries and return to the lives they love.
            </p>
            <p className="text-lg text-gray-600 leading-relaxed" data-id="element-185">
              At Arissa Cost Solutions, our human-centered approach ensures that
              injured workers receive the right care at the right time,
              providing peace of mind for them and their families while
              delivering measurable results for your bottom line.
            </p>
          </motion.div>

          {/* Bento Grid */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="lg:col-span-8" data-id="element-186">
            <div className="grid grid-cols-2 md:grid-cols-3 gap-4 auto-rows-[200px]" data-id="element-187">
              {/* Large Feature Image */}
              <div className="col-span-2 row-span-2 relative rounded-2xl overflow-hidden group" data-id="element-188">
                <img src="https://images.unsplash.com/photo-1609220136736-443140cffec6?ixlib=rb-4.0.3&auto=format&fit=crop&w=2400&q=90" alt="Older couple smiling together" className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" data-id="element-189" />
                <div className="absolute inset-0 bg-gradient-to-t from-brand-navy/80 via-brand-navy/20 to-transparent" data-id="element-190"></div>
                <div className="absolute bottom-6 left-6 right-6" data-id="element-191">
                  <p className="text-white font-serif text-2xl md:text-3xl font-medium leading-snug" data-id="element-192">
                    ...and a family waiting for them to come home.
                  </p>
                </div>
              </div>

              {/* Small Grid Images */}
              <div className="rounded-2xl overflow-hidden relative group hidden md:block" data-id="element-193">
                <img src="https://images.unsplash.com/photo-1581578731548-c64695cc6952?ixlib=rb-4.0.3&auto=format&fit=crop&w=1600&q=90" alt="Physical therapy and recovery" className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" data-id="element-194" />
                <div className="absolute inset-0 bg-brand-navy/10 group-hover:bg-transparent transition-colors duration-500" data-id="element-195"></div>
              </div>

              <div className="rounded-2xl overflow-hidden relative group hidden md:block" data-id="element-196">
                <img src="https://images.unsplash.com/photo-1559757148-5c350d0d3c56?ixlib=rb-4.0.3&auto=format&fit=crop&w=1600&q=90" alt="Construction worker on site" className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" data-id="element-197" />
                <div className="absolute inset-0 bg-brand-navy/10 group-hover:bg-transparent transition-colors duration-500" data-id="element-198"></div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}